import React from "react";

import { DetailItemType } from "../types";

type Props = Pick<DetailItemType, "date" | "year">;

const ItemDate: React.FC<Props> = ({ date, year }) => {
  return (
    <div className="mb-2 flex shrink-0 font-semibold sm:mb-0 sm:block">
      <div className="sm:min-w-[3.375rem]">{date}</div>
      {year && <div className="ml-1 text-grey-80 sm:ml-0 sm:mt-2 sm:text-xs">{year}</div>}
    </div>
  );
};

export default ItemDate;
